/* ==========================================================================
   MERIDIAN — article.js
   The reading layer. Loaded only on the article template.

     1. Heading IDs      — slugged from the heading text, stable for anchors
     2. Table of contents — built from the article body, desktop + mobile
     3. Scrollspy         — highlights the section you are actually reading
     4. Reading progress  — measured against the article, not the page
     5. Share             — native share sheet where available, copy link fallback
   ========================================================================== */
(function () {
  'use strict';

  var body = document.querySelector('[data-article-body]');
  if (!body) return;

  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ------------------------------------------------- 1. Heading IDs + anchors */
  var used = {};
  function slugify(text) {
    var base = text.toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'section';
    if (used[base]) {
      used[base] += 1;
      return base + '-' + used[base];
    }
    used[base] = 1;
    return base;
  }

  var headings = $$('h2, h3', body).filter(function (h) { return h.textContent.trim().length > 1; });
  headings.forEach(function (h) {
    if (!h.id) h.id = slugify(h.textContent);
  });

  /* ------------------------------------------------------ 2. Table of contents */
  var tocTargets = $$('[data-toc]');

  if (!headings.length) {
    tocTargets.forEach(function (t) {
      var host = t.closest('.toc, .toc-mobile');
      if (host) host.style.display = 'none';
    });
  } else {
    tocTargets.forEach(function (target) {
      var list = document.createElement('nav');
      list.className = 'toc__list';
      list.setAttribute('aria-label', 'Article sections');

      headings.forEach(function (h) {
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.setAttribute('data-level', h.tagName === 'H3' ? '3' : '2');
        list.appendChild(a);
      });

      target.appendChild(list);
    });
  }

  var tocLinks = $$('.toc [data-toc] a');

  /* --------------------------------------------------------------- 3. Scrollspy */
  if (tocLinks.length && 'IntersectionObserver' in window) {
    var visible = {};

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });

      // The "current" section is the topmost heading still in view.
      var currentId = null;
      for (var i = 0; i < headings.length; i++) {
        if (visible[headings[i].id]) { currentId = headings[i].id; break; }
      }
      // Nothing in the band? Fall back to the last heading scrolled past.
      if (!currentId) {
        var passed = headings.filter(function (h) { return h.getBoundingClientRect().top < 140; });
        if (passed.length) currentId = passed[passed.length - 1].id;
      }

      tocLinks.forEach(function (a) {
        a.classList.toggle('is-current', a.getAttribute('href') === '#' + currentId);
      });
    }, { rootMargin: '-15% 0px -70% 0px', threshold: 0 });

    headings.forEach(function (h) { spy.observe(h); });
  }

  // Close the mobile TOC after a jump so the reader lands on the content.
  var mobileToc = document.querySelector('.toc-mobile');
  if (mobileToc) {
    mobileToc.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') mobileToc.removeAttribute('open');
    });
  }

  /* -------------------------------------------------------- 4. Reading progress */
  var bar = document.querySelector('[data-progress-bar]');
  if (bar) {
    var ticking = false;

    function update() {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var p = total > 0 ? Math.min(Math.max(scrolled / total, 0), 1) : 0;
      bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* -------------------------------------------------------------------- 5. Share */
  $$('[data-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-url') || window.location.href;
      var title = btn.getAttribute('data-title') || document.title;
      var kind = btn.getAttribute('data-share');

      if (kind === 'native' && navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () { /* dismissed */ });
        return;
      }

      if (kind === 'copy' || kind === 'native') {
        var done = function () {
          var original = btn.getAttribute('aria-label');
          btn.setAttribute('aria-label', 'Link copied');
          btn.classList.add('is-copied');
          setTimeout(function () {
            btn.setAttribute('aria-label', original);
            btn.classList.remove('is-copied');
          }, 1800);
        };

        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(done).catch(function () {});
        } else {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          try { document.execCommand('copy'); done(); } catch (err) { /* no-op */ }
          document.body.removeChild(input);
        }
      }
    });
  });
})();
